(function () {
  'use strict';

  angular.module('app.studentImpactReport', [
  ]);
})();
